import { z } from 'zod'
import i18n from '@/lib/i18n'

export const cartaoAmareloSchema = z.object({
	date: z.string().refine((val) => !Number.isNaN(Date.parse(val)), {
		message: i18n.t('form.yellowCard.dateError'),
	}),
	employeeId: z.uuid(i18n.t('form.yellowCard.employeeIdError')),
	leaderId: z.uuid(i18n.t('form.yellowCard.leaderIdError')),
	potential: z.string().optional(),
	kindId: z.uuid(i18n.t('form.yellowCard.typologyError')),
	riskId: z.uuid(i18n.t('form.yellowCard.riskError')),
	unsafeDescription: z
		.string()
		.min(10, i18n.t('form.yellowCard.unsafeDescriptionError')),
	safeDescription: z
		.string()
		.min(10, i18n.t('form.yellowCard.safeDescriptionError')),
	image: z.any().optional(),
})

// input (o que o form manda para o resolver)
export type CartaoAmareloInput = z.input<typeof cartaoAmareloSchema>

// output (já coercido/validado; com Date)
export type CartaoAmareloFormData = z.output<typeof cartaoAmareloSchema>
